import { render, staticRenderFns } from "./iDalgo-Liveblog-Creator.vue?vue&type=template&id=57fc8377"
import script from "./iDalgo-Liveblog-Creator.vue?vue&type=script&lang=js"
export * from "./iDalgo-Liveblog-Creator.vue?vue&type=script&lang=js"
import style0 from "./iDalgo-Liveblog-Creator.vue?vue&type=style&index=0&id=57fc8377&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports